import { Framework } from '@/framework';

/** 鼠标悬停提示的实例级状态与订阅入口。 */
export class MouseHover extends Framework {
    /** 当前编辑器实例的双击提示是否可见。 */
    private doubleClickTipVisible = true;
    /** MouseHover 实例内部使用的可见性变化事件，不作为跨插件契约。 */
    private visibleEventName = 'mouse-hover-double-click-tip-visible-change';

    /** 返回当前编辑器实例是否展示双击提示。 */
    isDoubleClickTipVisible() {
        return this.doubleClickTipVisible;
    }

    /** 显示双击文案提示 */
    showDoubleClickTip() {
        this.doubleClickTipVisible = true;
        this.framework.service.events.emit(this.visibleEventName, true);
    }

    /** 隐藏双击文案提示 */
    hideDoubleClickTip() {
        this.doubleClickTipVisible = false;
        this.framework.service.events.emit(this.visibleEventName, false);
    }

    /** 监听双击文案提示可见性变化 */
    onVisibleChange(callback: (visible: boolean) => void) {
        const handler = this.framework.service.events.on(this.visibleEventName, callback);

        return () => {
            this.framework.service.events.off(handler);
        };
    }
}
